<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-twitter</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.twitter') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 10px 0 10px;"/>
      <span style="color:rgba(0, 0, 0, 0.54);">{{$t('twitter.account')}}</span>
      <v-text-field
        v-model="account"
        append-icon="mdi-search"
        hideDetails
        single-line
        style="margin-left: 15px;"
        @input="handleSetAccount"
      />
    </v-toolbar>
    <!-- <div style="padding: 0 10px 10px 10px;">
      
      <v-text-field
        v-model="account"
        append-icon="mdi-search"
        :label="$t('twitter.account')"
        hideDetails
        @input="handleSetAccount"
      />
    </div> -->
  </div>
</template>

<script>
  export default {
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
      account: ''
    }),
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
    created () {
      this.handleSetAccount = _.debounce(() => {
        this.onSetAccount(this.account)
      }, 500)
    },
    mounted() {
      this.account = this.content.TwitterAccount
    },
    methods: {
      onSetAccount() {
        this.content.Account = ''
        const that = this
        setTimeout(function(){
            that.content.TwitterAccount = that.account
        }, 500);
        
        this.handleChangeIsModified
      },
      handleChangeIsModified () {
        this.$store.state.app.isModified = false
      }
    }
  }
</script>

<style scoped>
</style>

